import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import Form from 'react-bootstrap/Form';

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  //console.log(props.data)
  /* questi non li uso
  const [{ name, email, message }, setState] = useState(initialState);
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  */
  const [txtNome, setTxtNome] = useState("");
  const [txtEmai, setTxtEmai] = useState("");
  const [txtMess, setTxtMess] = useState("");
  const [isError, setIsError] = useState(false);
  function handleEmailChange(valx) {
   
       setTxtEmai(valx);
    
    // Perform any other actions needed when the email changes
  }
  function validateEmail($email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test( $email );
  }
  const handleInvia = (e) => {
  setIsError(false)
  if (txtNome=='' || txtEmai=='' || txtMess=="") {
    setIsError(true)
    return
  };  
  if (validateEmail(txtEmai)==false) {
    setIsError(true)
    return
  };  
  var myHeaders = new Headers();  
      myHeaders.append("Content-Type", "application/json");
      //myHeaders.append("Authorization", "Bearer "+aGV.token);
      var raw = JSON.stringify({
        customer: "GKDEMO", //"cust01",
        from: "info@GKConsulting.it" ,
        to: "alberto.cappelli@GKConsulting.it" ,
        cc: "",
        sub: "GK_Web Richiesta informazioni",
        body: "Richiesta di contatto dal sito GK; nome:"+txtNome+" email:"+txtEmai+" testo:"+txtMess,
        sendType: "MAIL"
      });
      var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
       };
       var c="https://GKconsulting.it/ws/PIP_Ws/"
       var url = c + "InvioMail/InvioFast" //   : https://www.ellegm.it/AMG_Portale/Amg/ws/PIP_Ws/"
       console.log(url)
       console.log(raw)
       //return
       fetch(url, requestOptions) 
         .then((response) => response.json())
         .then((datiricevuti) => {
          //console.log(datiricevuti)
          //  console.log("datiricevuti"    )
          if (datiricevuti.status == "INVIATA") {
            var cM=props.data.messOK
            alert(cM)
            return
          } else {
             //console.log(datiricevuti.error);
             alert(datiricevuti.error)
          }
      })
       .catch( err =>  {  
         alert(err.message)
      })
}


  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2> {props.data ? props.data.contactUs : "loading"}</h2>
                <p>
                {props.data ? props.data.fillData : "loading"}
                </p>
              </div>
              <div   >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.data ? props.data.nome : "loading"}
                        required
                        value={txtNome} 
                        onChange={(event)=> setTxtNome(event.target.value)}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={txtEmai} 
                        onChange={(event) => handleEmailChange(event.target.value)}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder={props.data ? props.data.messaggio : "loading"}
                    required
                    value={txtMess} 
                    onChange={(event)=> setTxtMess(event.target.value)}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                {isError &&
                <p style={{ color: 'yellow' }}> {props.data ? props.data.compila : "loading"}</p>}
               
                <button  className="btn btn-custom btn-lg"  onClick={handleInvia}>
                 {props.data ? props.data.sendMessage : "loading"}
                 
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
      
            <div className="contact-item">
              <p>
                 {props.data ? props.data.name : "loading"}<br></br>
                 {props.data ? props.data.partitaIva : "loading"}<br></br>
                 {props.data ? props.data.pec : "loading"}<br></br>
                 {props.data ? props.data.regImp : "loading"}<br></br>
                 {props.data ? props.data.capSoc : "loading"}
              </p>
            </div>
            <div className="contact-item">
             <p>
                <span>
                  <i className="fa fa-map-marker"></i> {props.data ? props.data.where : "loading"}
                </span>
               
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
              </div>
            </div>
            <div className="col-md-12">
            <div className="row">
              <p>{"Last upd: 16/02/2026"}</p>
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.instagram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                 
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2026 GK Consulting {" "}
            <a hidden href="http://www.templatewire.com" rel="nofollow">
              TemplateWire
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
